import React from "react";
import "./styles.scss";
import moment from "moment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Popconfirm } from "antd";
import { useSelector } from "react-redux";
import { Button, Tag } from "..";

const AdminGazetteCard = (props) => {
  const { tagsList } = useSelector(({ tagsReducer }) => tagsReducer);
  const onClickCancel = (e) => {
    console.log(e);
  };

  return (
    <>
      <div
        className={`hne-gazette-card-wrapper ${
          props?.isSelect ? "active" : ""
        }`}
      >
        <div className="d-flex flex-row ">
          <div className="gcw-logo">
            <div className={"gvcmw__news-date"}>
              <span className={"tncmw__nd-day"} style={{ marginRight: "10px" }}>
                {moment(props?.closeDate).format("DD")}
              </span>
              <span className={"tncmw__nd-month"}>
                {moment(props?.closeDate).format("MMM")}
              </span>
            </div>
          </div>
          <div className="gcw-details-wrapper ml-3">
            <div className="gcw-title-en">{props.titleEn}</div>
            <div className="gcw-title-si">{props.titleSi}</div>
            <div className="gcw-date">
              Gazette Date: {moment(props?.closeDate).format("YYYY-MM-DD")}
            </div>

            {Array.isArray(props?.tags) && props.tags.length > 0 && (
              <div
                className="gcw-name"
                style={{ gap: "4px", display: "flex", flexWrap: "wrap" }}
              >
                {props.tags.map((tagId, index) => {
                  const tagData = tagsList.find((t) => t.tag_id === tagId);
                  return tagData ? (
                    <span key={index} style={{ marginRight: "4px" }}>
                      {tagData.tag_name}
                    </span>
                  ) : null;
                })}
              </div>
            )}

            <div style={{ width: "50px" }}>
              {" "}
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "eye",
                  tagName: props?.views,
                  type: "views_tag",
                }}
              />
            </div>
            {props?.type === "admin" && (
              <div className="gcw-buttons-wrapper">
                {/* <div className="gcw-view" onClick={props.onClickView}>
              {props.view}
            </div> */}

                {(props?.job_si || props?.job_en || props?.job_ta) && (
                  <div
                    className={`jvcmw__cba-download`}
                    style={{ marginTop: "8px", marginBottom: "12px" }}
                  >
                    <div className={`jvcmw__cbad-title`}>Job details (png)</div>
                    <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
                      {props?.job_si?.length > 0 && (
                        <Button
                          data={{
                            btnName: "SINHALA",
                            buttonType: "black",
                            buttonSize: "xs",
                            isLoading: false,
                          }}
                          onClick={props?.onClickDetailsSI}
                        />
                      )}
                      {props?.job_ta?.length > 0 && (
                        <Button
                          data={{
                            btnName: "TAMIL",
                            buttonType: "black",
                            buttonSize: "xs",
                            isLoading: false,
                          }}
                          onClick={props?.onClickDetailsTA}
                        />
                      )}
                      {props?.job_en?.length > 0 && (
                        <Button
                          data={{
                            btnName: "ENGLISH",
                            buttonType: "primary",
                            buttonSize: "xs",
                            isLoading: false,
                          }}
                          onClick={props?.onClickDetailsEN}
                        />
                      )}
                    </div>
                  </div>
                )}

                {(props?.procument_si ||
                  props?.procument_en ||
                  props?.procument_ta) && (
                  <div
                    className={`jvcmw__cba-download`}
                    style={{ marginTop: "8px", marginBottom: "12px" }}
                  >
                    <div className={`jvcmw__cbad-title`}>
                      Procument details (png)
                    </div>
                    <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
                      {props?.procument_si?.length > 0 && (
                        <Button
                          data={{
                            btnName: "SINHALA",
                            buttonType: "black",
                            buttonSize: "xs",
                            isLoading: false,
                          }}
                          onClick={props?.onClickProcumentSI}
                        />
                      )}
                      {props?.procument_ta?.length > 0 && (
                        <Button
                          data={{
                            btnName: "TAMIL",
                            buttonType: "black",
                            buttonSize: "xs",
                            isLoading: false,
                          }}
                          onClick={props?.onClickProcumentTA}
                        />
                      )}
                      {props?.procument_en?.length > 0 && (
                        <Button
                          data={{
                            btnName: "ENGLISH",
                            buttonType: "primary",
                            buttonSize: "xs",
                            isLoading: false,
                          }}
                          onClick={props?.onClickProcumentEN}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="d-flex flex-row">
          <div className="gcw-edit" onClick={props.onClickEdit}>
            {props.edit}
          </div>
          <div className="gcw-delete ml-3">
            <Popconfirm
              placement="topLeft"
              title="Delete the image"
              description="Are you sure to delete this Image?"
              onConfirm={props.onClickRemove}
              onCancel={onClickCancel}
              okText="Yes"
              cancelText="No"
            >
              {props.delete}
              {/* <span className="remove-button"> {GetIconByName("cross")}</span>{" "} */}
            </Popconfirm>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(AdminGazetteCard);
